import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "EnterpriseGroupDashboardPage" */
	'pages/EnterpriseGroup/EnterpriseGroupDashboardPage'));

export default [{ component, exact: true, path: '/enterprise_groups/:enterpriseGroupId' }];